import React, { FC } from 'react';
import { ReactComponent as Twitter } from '../../../assets/SocialMedia/Twitter.svg';

export const TwitterIcon: FC = () => <Twitter />;
